import Vue from 'vue'

export default {
   methods: {
      toggleMenu() {
      if (document.getElementById('nav-side-main').classList.contains('showNav')) {
        document.getElementById('nav-side-main').classList.remove('showNav')
        document.getElementById('nav-side').classList.remove('showNav')
      } else {
        document.getElementById('nav-side-main').classList.add('showNav')
        document.getElementById('nav-side').classList.add('showNav')
      }
    },
    logout() {
      Vue.prototype.$keycloak.logout();
    }
  }
}
